<template>
  <body class="footer">
    <div class="logo-wrapper">
      <img class="logo" :src="logoSrc" alt="logo" />
    </div>
    <div class="content-wrapper">
      <div class="icons-wrapper">
        <div>
          <img
            class="social-icon"
            :src="linkedinSrc"
            @mouseenter="changeIcon('linkedin', true)"
            @mouseleave="changeIcon('linkedin', false)"
            alt="linkedin"
          />
        </div>
        <div>
          <img
            class="social-icon"
            :src="facebookSrc"
            @mouseenter="changeIcon('facebook', true)"
            @mouseleave="changeIcon('facebook', false)"
            alt="facebook"
          />
        </div>
        <div>
          <img
            class="social-icon"
            :src="instagramSrc"
            @mouseenter="changeIcon('instagram', true)"
            @mouseleave="changeIcon('instagram', false)"
            alt="instagram"
          />
        </div>
      </div>
      <div class="signup-wrapper">
        <div class="text">
          Sign up and be an early user of our upcoming features
        </div>
        <div class="input-wrapper">
          <input
            type="text"
            id="e-mail"
            name="e-mail"
            value="E-mail"
            onclick="this.value=''"
          />
          <a
            href="mailto:info@wecobi.com?subject=Sign Up list&body=I would like to sign up and be an early user of Your upcoming features."
            class="button"
          >
            <img :src="arrowRightSrc" alt="arrow-right" />
          </a>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import logoSrc from "../../assets/Logo-footer.png";
import linkedin from "../../assets/linkedin.png";
import linkedinOrange from "../../assets/linkedin-orange.png";
import facebook from "../../assets/facebook.png";
import facebookOrange from "../../assets/facebook-orange.png";
import instagram from "../../assets/instagram.png";
import instagramOrange from "../../assets/instagram-orange.png";
import arrowRight from "../../assets/arrow-right.svg";

export default {
  name: "Footer",
  data() {
    return {
      logoSrc,
      linkedinSrc: linkedin,
      facebookSrc: facebook,
      instagramSrc: instagram,
      arrowRightSrc: arrowRight,
      icons: {
        linkedin: { default: linkedin, hover: linkedinOrange },
        facebook: { default: facebook, hover: facebookOrange },
        instagram: { default: instagram, hover: instagramOrange },
      },
    };
  },
  methods: {
    changeIcon(platform, isHover) {
      this[`${platform}Src`] = isHover
        ? this.icons[platform].hover
        : this.icons[platform].default;
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100%;
  height: 764px;
  background: #000000;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 232px;
  height: 53px;
}
.content-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 78px;
}
.icons-wrapper {
  max-width: 265px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
}
.social-icon {
  width: 70px;
  height: 70px;
  cursor: pointer;
}
.signup-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.text {
  font-size: 25px;
  color: #babcc0;
  max-width: 370px;
}
.input-wrapper {
  display: flex;
  gap: 8px;
}
input {
  width: 232px;
  max-height: 50px;
  outline: 0;
  border: 2px solid #434343;
  border-radius: 7px;
  background-color: #000000;
  color: #babcc0;
  font-size: 16px;
  font-weight: 500;
  padding: 15px 0px 15px 15px;
}
input:focus {
  outline: none;
}
input:hover {
  border: 2px solid #ff6d0a;
  color: #ff6d0a;
}
.button {
  width: 47px;
  height: 50px;
  background: #434343;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
}
.button:hover {
  background: #ff6d0a;
}

@media (max-width: 1280px) {
  .logo {
    width: 217px;
    height: 49px;
  }
  .text {
    font-size: 20px;
    max-width: 306px;
  }
}
@media (max-width: 1025px) {
  .footer {
    height: 640px;
  }
  .social-icon {
    width: 52px;
    height: 52px;
  }
  .text {
    font-size: 18px;
    max-width: 302px;
  }
  .input {
    max-height: 48px;
  }
}
@media (max-width: 744px) {
  .footer {
    height: 652px;
    justify-content: space-evenly;
  }
  .content-wrapper {
    flex-direction: column;
    gap: 69px;
  }
  .logo {
    width: 153px;
    height: 35px;
  }
}
@media (max-width: 588px) {
  .footer {
    height: 673px;
  }
}

@media (max-width: 430px) {
  .footer {
    height: 661px;
  }
}
</style>
